import WorkRuleTable from "components/table/work_rules/WorkRuleTable"

const WorkRules = () => {
    
    return (
        <>
            <WorkRuleTable />
        </>
    )
}

export { WorkRules }